import { PLAN_USAGE } from '../planUsageDesignTokens'

export function cellBackground(level) {
  switch (level) {
    case 1:
      return PLAN_USAGE.heatLow
    case 2:
      return PLAN_USAGE.heatMid
    case 3:
      return PLAN_USAGE.heatHigh
    default:
      return PLAN_USAGE.heatEmpty
  }
}
